export default __webpack_public_path__ + "static/media/menupl-sm.f2d6a3ac.svg";